import React from 'react'
import PropTypes from 'prop-types'
import Loader from 'react-loader-spinner'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import styles from '../../../../../shared/styles/colors.scss'
import './JVLoader.scss'

const JVLoader = ({ loading }) => (
  loading && (
    <div className="app-loading">
      <div className="loading-container">
        <Loader
          type="ThreeDots"
          color={styles.primary}
          height={60}
          width={60}
        />
        <span style={{ color: styles.primary }}>Routing to<br /> the Appointment Requests</span>
      </div>
    </div>
  )
)

JVLoader.defaultProps = {
  loading: false
}

JVLoader.propTypes = {
  loading: PropTypes.bool
}


export default JVLoader
